import React from 'react';
import { DateField } from '@jutro/legacy/components';

function WniDateField(props) {
    return <DateField displayFormat="short" openWithIconOnly {...props}/>
}

export default WniDateField;
